<template>
  <div class="app-container">
    <div>
      <label>{{ $t('common.orders') }}</label>
      <CrudTable
        entity="StoreOrderLine"
        :columns="columns"
        :show-action-icons-in-list="true"
        :always-show-pagination="true"
        :on-row-dbl-click="() => {}"
        :show-close="false"
        :persist-state="false"
        :custom-actions="getCustomListActions()"
        :limit="10"
      />
    </div>
    <div style="padding-top:25px">
      <label>{{ $t('orderLine.orderLinesCancelledLastMonth') }}</label>
      <CrudTable
        entity="StoreOrderLinesCancelled"
        :columns="columns"
        :show-action-icons-in-list="true"
        :always-show-pagination="true"
        :on-row-dbl-click="() => {}"
        :show-close="false"
        :persist-state="false"
        :custom-actions="getCustomListActions()"
        :limit="10"
      />
    </div>
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
import orderlistMixin from './../orderlist-mixin';
import { Labels } from './../orderlist-mixin';

export default {
  components: {
    CrudTable
  },
  mixins: [orderlistMixin],
  data() {
    return {
      columns: [
        { field: 'id', label: 'orderLine.ticketNumber', width: '150px' },
        { field: 'customerReference', label: 'orderLine.customerReference', width: '130px' },
        { field: 'orderedAt', label: 'orderLine.orderDate', minWidth: '110px', type: 'date', filter: { type: 'date' } },
        { field: 'consumerName', label: 'orderLine.consumerName', minWidth: '160px' },
        {
          field: 'orderLineStatus',
          label: 'orderLine.orderLineStatus',
          minWidth: '100px',
          formatter: this.formatOrderLineStatus,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('orderLineStatus'),
            valueField: 'code',
            labelField: 'description'
          }
        },
        {
          field: 'orderLineSubstatusName',
          label: 'orderLine.orderLineSubstatus',
          minWidth: '100px',
          filter: {
            type: 'select',
            options: this.orderLineStatuses,
            valueField: 'id',
            labelField: 'name'
          }
        },
        {
          field: 'deliveryDate',
          label: 'orderLine.deliveryDate',
          width: '115px',
          type: 'date',
          filter: { type: 'date' }
        },
        {
          field: 'transportOrderLineSubstatusName',
          label: 'orderLine.transportStatus',
          minWidth: '100px',
          filter: {
            type: 'select',
            options: this.transportStatuses,
            valueField: 'id',
            labelField: 'name'
          }
        },
        {
          field: 'transportStatusChangedAt',
          label: 'orderLine.transportStatusChangedAt',
          minWidth: '135px',
          type: 'dateTime',
          sortable: false,
          filter: { type: 'date' }
        },
        {
          field: 'productGroupDescription',
          label: 'orderLine.productGroup',
          minWidth: '120px',
          filter: {
            type: 'select',
            options: this.productGroups,
            valueField: 'description',
            labelField: 'description'
          }
        },
        { field: 'fabricName', label: 'orderLine.fabricName', minWidth: '140px' },
        {
          field: 'deliverAtHomeYN',
          label: 'orderLine.delivery',
          formatter: this.formatDeliverAtHomeYN,
          width: '90px',
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t(Labels.Deliver) },
              { value: false, label: this.$t(Labels.PickUp) }
            ],
            valueField: 'value',
            labelField: 'label'
          }
        },
        { field: 'source', label: 'order.source', minWidth: '100px' }
      ]
    };
  }
};
</script>
